import { axios, getAxiosConfig } from '@config/axios';
import Environment from '@config/index';
import logger from '@helpers/utils/logger/client';
import Cookies from 'universal-cookie';
import { AppCookies } from '@enums/cookies';

const apiBaseUrl = Environment.apiBaseUrl;

export interface ShoppingPrefsPayload {
  universe?: number;
  categories?: number[];
  custom?: string[];
  updated_at?: string;
}

export class UserShoppingPreferencesService {
  static url = `${apiBaseUrl}/users/me/shopping-preferences`;

  static getShoppingPrefsAxiosConfig() {
    const axiosConfig = getAxiosConfig();
    if (typeof window === 'undefined') {
      return axiosConfig;
    }

    const searchParams = new URLSearchParams(window.location.search);
    const shouldAddCustomIdHeader = searchParams.get('addCustomIdToShopPref') === 'true';
    if (!shouldAddCustomIdHeader) {
      return axiosConfig;
    }

    const cookies = new Cookies(document.cookie);
    const rawUserId = cookies.get<string>(AppCookies.UID, { doNotParse: true });
    const userId = Number(rawUserId);
    if (!rawUserId || !Number.isInteger(userId) || userId <= 0) {
      return axiosConfig;
    }

    return {
      ...axiosConfig,
      headers: {
        ...(axiosConfig.headers || {}),
        'X-Consumer-Custom-ID': String(userId),
      },
    };
  }

  static async getShoppingPrefs(): Promise<ShoppingPrefsPayload> {
    const axiosConfig = this.getShoppingPrefsAxiosConfig();
    try {
      const { data } = await axios.get<ShoppingPrefsPayload>(this.url, axiosConfig);
      return data;
    } catch (error) {
      logger.error('shopping-preferences-service::getShoppingPrefs::', error?.response?.data);
      throw error;
    }
  }

  static async updateShoppingPrefs(payload: ShoppingPrefsPayload): Promise<void> {
    const axiosConfig = this.getShoppingPrefsAxiosConfig();
    try {
      await axios.patch(this.url, payload, axiosConfig);
    } catch (error) {
      logger.error('shopping-preferences-service::updateShoppingPrefs::', error?.response?.data);
      throw error;
    }
  }
}
